require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/number/is-integer.js